import React, { FunctionComponent, useState } from 'react';

import { ApiHelper } from '../../helpers';
import { FaMinusSquare } from 'react-icons/fa';
import { FileFieldType } from '../../types';
import { IconButton } from '.';
import axios from 'axios';
import classNames from 'classnames';
import { getIn } from 'formik';
import { useErrorHandler } from '../../hooks';
import { useTranslation } from 'react-i18next';

const FileField: FunctionComponent<FileFieldType> = ({ formikProps, label, name, disabled, required }) => {
  const [loadingFile, setLoadingFile] = useState(false);
  const errorHandler = useErrorHandler();
  const { t } = useTranslation();

  let errors = getIn(formikProps.touched, name) && getIn(formikProps.errors, name);
  let hasErrors = false;

  if (typeof errors !== 'string' && !React.isValidElement(errors)) {
    errors = [getIn(formikProps.touched, name) && getIn(formikProps.errors, `${name}.id`)];
  }

  if (Array.isArray(errors)) {
    hasErrors = !!errors.filter((value: any) => value).length;
  } else if (typeof errors === 'string') {
    hasErrors = true;
  }

  return (
    <div>
      <label
        htmlFor={`formFile${name}`}
        className={classNames('form-label', formikProps.touched?.[name] && hasErrors && 'text-danger')}
      >
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      {loadingFile ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">{t('label.carregando_arquivo')}</span>
          </div>
        </div>
      ) : getIn(formikProps.values, `${name}.id`) > 0 ? (
        <div className={classNames('d-flex', formikProps.touched?.[name] && hasErrors && 'is-invalid')}>
          <IconButton
            title={t('label.remover_arquivo')}
            onClick={() => {
              formikProps.setFieldValue(name, {
                content_type: '',
                id: 0,
                length: '',
                nome: '',
              });
            }}
            Icon={<FaMinusSquare size="1.75em" />}
          />
          <input
            type="text"
            className={classNames('form-control', 'ms-1', formikProps.touched?.[name] && hasErrors && 'is-invalid')}
            disabled
            value={getIn(formikProps.values, `${name}.nome`)}
          />
        </div>
      ) : (
        <input
          type="file"
          id={`file-field-${name}`}
          className={classNames('form-control', formikProps.touched?.[name] && hasErrors && 'is-invalid')}
          disabled={disabled}
          onChange={async (event: any) => {
            setLoadingFile(true);
            formikProps.setFieldTouched(name, true);
            let file = event.currentTarget.files[0];

            let formData = new FormData();
            formData.append('arquivo', file);
            axios
              .post(ApiHelper.getUrl.apiArquivo.upload(), formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then(function (response) {
                formikProps.setFieldValue(name, response.data);
              })
              .catch(function (error) {
                errorHandler(error);
              })
              .finally(() => setLoadingFile(false));
          }}
        />
      )}
      {formikProps.touched?.[name] && hasErrors && <div className="invalid-feedback">{errors}</div>}
    </div>
  );
};

export default FileField;
